import { gsap } from 'gsap'

/**
 * Cursor-Spotlight für Karten (Vercel-Motiv): pro `.spot-card` werden
 * --spot-x/--spot-y via GSAP-quickSetter nachgeführt, das CSS-Overlay
 * (main.css) rendert daraus einen radialen Lichtkegel unterm Cursor.
 *
 * Läuft nur mit feinem Pointer und ohne reduced-motion — Touch/Reduced
 * behalten die statische Karte, das Overlay bleibt unsichtbar.
 */
export function useSpotlight(container: Ref<HTMLElement | null>, selector = '.spot-card') {
  let teardown: Array<() => void> = []

  onMounted(async () => {
    await nextTick()
    if (!container.value) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    if (!window.matchMedia('(pointer: fine)').matches) return

    container.value.querySelectorAll<HTMLElement>(selector).forEach((card) => {
      const setX = gsap.quickSetter(card, '--spot-x', 'px')
      const setY = gsap.quickSetter(card, '--spot-y', 'px')
      const move = (e: PointerEvent) => {
        const r = card.getBoundingClientRect()
        setX(e.clientX - r.left)
        setY(e.clientY - r.top)
      }
      card.addEventListener('pointermove', move, { passive: true })
      teardown.push(() => card.removeEventListener('pointermove', move))
    })
  })

  onBeforeUnmount(() => {
    teardown.forEach(fn => fn())
    teardown = []
  })
}
